import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "max-w-2xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Reviews", -1)
const _hoisted_4 = { class: "mt-6 pb-10 border-t border-b border-gray-200 divide-y divide-gray-200 space-y-10" }
const _hoisted_5 = { class: "lg:col-start-5 lg:col-span-8 xl:col-start-4 xl:col-span-9 xl:grid xl:grid-cols-3 xl:gap-x-8 xl:items-start" }
const _hoisted_6 = { class: "flex items-center xl:col-span-1" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "ml-3 text-sm text-gray-700" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " out of 5 stars", -1)
const _hoisted_10 = { class: "mt-4 lg:mt-6 xl:mt-0 xl:col-span-2" }
const _hoisted_11 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_12 = { class: "mt-3 space-y-6 text-sm text-gray-500" }
const _hoisted_13 = { class: "mt-6 flex items-center text-sm lg:mt-0 lg:col-start-1 lg:col-span-4 lg:row-start-1 lg:flex-col lg:items-start xl:col-span-3" }
const _hoisted_14 = { class: "font-medium text-gray-900" }
const _hoisted_15 = ["datetime"]

import { StarIcon } from "@heroicons/vue/solid/esm/index.js";
import { nextTick, onMounted, reactive } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewsHome',
  setup(__props) {

let reviews: any = reactive([
  //   {
  //     id: 1,
  //     title: "Stop looking and book it",
  //     rating: 5,
  //     content: `
  //      <p>I had written down 40 plus places to call. Researched their numbers n was doing that when i found this place. Immediately i stopped looking and gave it a try. The price was really good for 4 people sleeping, plus relatively private. We stayed for 4 nights. I felt like it was not just designed for business but really belonged to a family who designed it with their own comfort and beauty in mind. What stuck out for me- we had access to everything we needed or may have forgotten. Mosquito repellant, sun block, cooler, snorkling equipment, bike etc.
  // I never stay in the same place twice but wud seriously consider it for here.
  // Totally worth it.</p>
  // Place - much attention to details. Beautiful art. The table tops are hand crafted.<br />
  // Library - great authors. Borrowed n Read out a book whilst there.<br />
  // Pool - well mentained. Not too strong chlorine. Jumñing board. Relaxing views.<br />
  // Staff - very helpful, friendly.<br />
  // Cabana - felt very private even when we spent a LOT of the time in the gallery. They are designed that way. Each cabana with a almost private gallery.<br />
  // Beach - we took about 10 mins with 2 kids. It was great for snorkling. Lots of ripe mangoes on the way to eat.<br />
  // Nature - loved the sounds of birds every morning. The place was mosquito proofed.<br />
  // Had many hammocks.<br />
  // Bella - dog accompanied us each time to the beach. Stayed the whole time on the beach. Acted like a lil guard dog. Didnt allow strangers to come close to our group. Kids n hisband loved him. Very friendly to our guest. Intelligent dog.<br />
  // Suggestion for improvement- cant think of any now. Neither my husband. Oh it was also our 14th anniversary. Totally worth it.<br />
  //     `,
  //     author: "Guest",
  //     date: "July, 2020",
  //     datetime: "2020-07-01",
  //   },
  //   // More reviews...
]);

onMounted(() => {
  fetch("/api/reviews?location=homepage").then(async (resp: any) => {
    let { data } = await resp.json();
    data.forEach((d: any) => reviews.push(d));
    // console.log(reviews);
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reviews), (review) => {
          return (_openBlock(), _createElementBlock("div", {
            key: review.id,
            class: "pt-10 lg:grid lg:grid-cols-12 lg:gap-x-8"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4], (rating) => {
                    return _createVNode(_unref(StarIcon), {
                      key: rating,
                      class: _normalizeClass([
                    review.rating > rating ? 'text-yellow-400' : 'text-gray-200',
                    'h-5 w-5 flex-shrink-0',
                  ]),
                      "aria-hidden": "true"
                    }, null, 8, ["class"])
                  }), 64))
                ]),
                _createElementVNode("p", _hoisted_8, [
                  _createTextVNode(_toDisplayString(review.rating), 1),
                  _hoisted_9
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", _hoisted_11, _toDisplayString(review.title), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(review.body), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("p", _hoisted_14, _toDisplayString(review.guestName), 1),
              _createElementVNode("time", {
                datetime: review.datetime,
                class: "ml-4 border-l border-gray-200 pl-4 text-gray-500 lg:ml-0 lg:mt-2 lg:border-0 lg:pl-0"
              }, _toDisplayString(review.date), 9, _hoisted_15)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})